export enum SectorEquipmentType {
  Alpha = 'Alpha',
  Beta = 'Beta',
  Gamma = 'Gamma',
  Delta = 'Delta',
}
